// 注入组件到全局中
import ByRow from './by-row/index';
import ByCol from './by-col/index';
import ByButton from './by-button/button.vue';
import SvgIcon from './SvgIcon.vue'
import Dialog from './by-dialog/Dialog.vue'

export default {
  install(Vue) {
    Vue.component('ByRow', ByRow);
    Vue.component('ByCol', ByCol);
    Vue.component('ByButton', ByButton);
    Vue.component('SvgIcon', SvgIcon);
    Vue.component('Dialog', Dialog);
  }
}